import { Button } from '@repo/shadcn';
import { ColumnDef, Row } from '@tanstack/react-table';
import { Link } from 'react-router-dom';

import { Route } from '@/constants';
import { formatCurrencyInBDT } from '@/utils/currency-formater';

export const columns: ColumnDef<any>[] = [
    {
        accessorKey: 'name',
        header: () => {
            return <span>Name</span>;
        },
        cell: ({ row }) => (
            <Link to={`${Route.WHOLESALE_ORDER_CUSTOMERS}/${row.original.id}`}>
                <Button
                    type="button"
                    variant={'link'}
                    size={'default'}
                    className="p-0 text-black"
                >
                    {row.getValue('name')}
                </Button>
            </Link>
        ),
    },

    {
        accessorKey: 'pending_requests',
        header: () => {
            return (
                <div className="flex justify-end">
                    <span className="text-right">Pending Requests</span>
                </div>
            );
        },
        cell: ({ row }) => (
            <div className="text-right font-medium">
                {row.getValue('pending_requests')}
            </div>
        ),
    },

    {
        accessorKey: 'total_due_amount',
        header: () => {
            return (
                <div className="flex justify-end">
                    <span className="text-right">Total Due Amount</span>
                </div>
            );
        },
        cell: ({ row }) => (
            <div className="text-right font-medium">
                {formatCurrencyInBDT(row.getValue('total_due_amount'))}
            </div>
        ),
    },

    {
        accessorKey: 'actions',
        header: () => <div className="text-right">Actions</div>,
        id: 'actions',
        enableHiding: false,
        cell: ({ row }) => {
            return <RowActionColumn row={row} />;
        },
    },
];

const RowActionColumn = ({ row }: { row: Row<any> }) => {
    return (
        <div className="flex items-center justify-end gap-1">
            <Link
                to={`${Route.WHOLESALE_ORDER_CUSTOMERS}/${row.original.id}`}
                className="text-blue-600 hover:underline"
            >
                <Button
                    type="button"
                    variant={'link'}
                    size={'default'}
                    className="p-0 text-black"
                >
                    View Details
                </Button>
            </Link>
        </div>
    );
};
